export default "__VITE_ASSET__DO8Q7lcb__"